import React from 'react';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ partner, onPartnerChange }) => {
  return (
    <Card className={styles.card} title="Adresse du partenaire" classTitle="title-green">

      <div className={styles.group}>

        <TextInput
          className={styles.field}
          label="Adresse"
          name="address"
          type="text"
          placeholder="Adresse complète"
          value={partner?.address || ''}
          onChange={onPartnerChange}
        />
        <TextInput
          className={styles.field}
          label="Complément d'adresse"
          name="address_complement"
          type="text"
          placeholder="Ex: Appartement, étage..."
          value={partner?.address_complement || ''}
          onChange={onPartnerChange}
        />
        <TextInput
          className={styles.field}
          label="Code Postal"
          name="zip_code"
          type="text"
          placeholder="Code postal"
          value={partner?.zip_code || ''}
          onChange={onPartnerChange}
        />
        <TextInput
          className={styles.field}
          label="Ville"
          name="city"
          type="text"
          placeholder="Ville"
          value={partner?.city || ''}
          onChange={onPartnerChange}
        />
        <TextInput
          className={styles.field}
          label="Département"
          name="department"
          type="number"
          value={partner?.department || ''}
          onChange={onPartnerChange}
        />
        <TextInput
          className={styles.field}
          label="Pays"
          name="country"
          type="text"
          placeholder="Pays"
          value={partner?.country || ''}
          onChange={onPartnerChange}
        />
      </div>
    </Card >
  );
};

export default AddressInformations;
